import { ref, unref } from 'vue';

/* NPM Plugins */
import { ElForm } from 'element-plus';

/* Components */
import { CreateByTempForm } from "../forms/Index"

export const useCreateByTemp = () => {

    const formRef = ref<typeof CreateByTempForm>()

    const elFormRef = ref<ComponentRef<typeof ElForm>>()

    const register = (ref: typeof CreateByTempForm, elRef: ComponentRef<typeof ElForm>) => {

        formRef.value = ref
        elFormRef.value = elRef

    }

    const methods = {

        getLoadStatus: () => {

            return unref(formRef)?.funcs.getLoadStatus()

        },

        setLoading: (isLoad: boolean) => {

            unref(formRef)?.funcs.setLoadStatus(isLoad);

        },

        setFormData: (data: any) => {

            unref(formRef)?.funcs.setFormData(data)

        },

        getFormData: () => {

            return unref(formRef)?.funcs.getFormData()

        }

    }

    return { elFormRef, register, methods }
}